
import { DataLoader } from "../../components/DataLoader";
import { CRMTable } from "./CRMTable";
import { CRMPagination } from "./CRMPagination";
import { CRMData, SortConfig } from "./types";

interface CRMTableSectionProps {
  isLoading: boolean;
  error: string | null;
  filteredData: CRMData[];
  sortConfig: SortConfig | null;
  onSort: (key: keyof CRMData) => void;
  currentPage: number;
  totalPages: number;
  goToPage: (page: number) => void;
  nextPage: () => void;
  prevPage: () => void;
}

export const CRMTableSection = ({
  isLoading,
  error,
  filteredData,
  sortConfig,
  onSort,
  currentPage,
  totalPages,
  goToPage,
  nextPage,
  prevPage,
}: CRMTableSectionProps) => {
  return (
    <div className="space-y-4">
      <DataLoader
        isLoading={isLoading}
        error={error}
        isEmpty={filteredData.length === 0}
        emptyMessage="Aucune donnée CRM trouvée"
      >
        <CRMTable 
          data={filteredData} 
          sortConfig={sortConfig} 
          onSort={onSort} 
        />
      </DataLoader>
      
      <CRMPagination
        currentPage={currentPage}
        totalPages={totalPages}
        goToPage={goToPage}
        nextPage={nextPage}
        prevPage={prevPage}
        totalRecords={filteredData.length}
        recordsPerPage={20} // Hardcoded as this is the value used in usePagination
      />
    </div>
  );
};
